import React, { Children } from "react"
import tw, { css, styled } from "twin.macro"
import TooltipClose from "../icons/tooltipClose"

interface Props {
  closeButtonClicked: () => void
}

const NSNHelpPopup: React.FC<Props> = ({ closeButtonClicked, children }) => (
  <>
    <BackgroundFill />
    <TooltipWrapper>
      <CloseButton onClick={closeButtonClicked}>
        <TooltipClose />
      </CloseButton>
      <TooltipContents>
        {children}
      </TooltipContents>
    </TooltipWrapper>
  </>
)

const BackgroundFill = styled.div`
  width: 100vw;
  height: 100%;
  position: fixed;
  background: black;
  opacity: 0.7;
  top: 0;
  left: 0;
`

const TooltipWrapper = styled.div`
  ${tw`absolute bottom-0 pb-12`},
`

const TooltipContents = styled.div`
  ${tw`bg-white p-4 text-white`}
`

const CloseButton = styled.button`
  padding-bottom: 0.6rem;
  ${tw`absolute bottom-0 right-0 focus:outline-none`}
`

export default NSNHelpPopup
